import { IBroker } from "../../models/IBroker";
import { BROKER_SET_BROKER } from "./broker-types";

export const setBrokers = (brokers: IBroker[]) => (dispatch: any) => {
  dispatch({ type: BROKER_SET_BROKER, payload: brokers });
};
